import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';

// Track page views
export const trackPageView = (path) => {
    // Only track if we're on a portfolio page (not admin)
    const isPortfolioPage = !path.startsWith('/admin');

    if (analytics && isPortfolioPage) {
        logEvent(analytics, 'page_view', {
            page_path: path,
            page_title: document.title
        });
    }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
    // Only track if we're on a portfolio page (not admin)
    const isPortfolioPage = !window.location.pathname.startsWith('/admin');

    if (analytics && isPortfolioPage) {
        logEvent(analytics, action, {
            category: category,
            label: label,
            value: value
        });
    }
};

/**
 * Track navigation clicks
 */
export const trackNavigation = (pageName) => {
    trackEvent('navigation_click', 'user_action', pageName);
};

/**
 * Track social media link clicks
 */
export const trackSocialMedia = (platform) => {
    trackEvent('social_media_click', 'user_action', platform);
};

/**
 * Track email link clicks
 */
export const trackEmail = () => {
    trackEvent('email_click', 'user_action', 'Contact Email');
};

/**
 * Track gallery/category clicks
 */
export const trackGalleryClick = (galleryName) => {
    trackEvent('gallery_click', 'user_action', galleryName);
};

/**
 * Track photo clicks
 */
export const trackPhotoClick = (photoId) => {
    trackEvent('photo_click', 'user_action', photoId);
};